import { render, staticRenderFns } from "./ltshareList.vue?vue&type=template&id=022f3de1&scoped=true&"
import script from "./ltshareList.vue?vue&type=script&lang=js&"
export * from "./ltshareList.vue?vue&type=script&lang=js&"
import style0 from "./ltshareList.vue?vue&type=style&index=0&id=022f3de1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022f3de1",
  null
  
)

export default component.exports